import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/caradd/:id',
    name: 'CarAdd',
    component: () => import('../views/CarAdd.vue')
  },
  {
    path: '/carparking/:id',
    name: 'CarParking',
    component: () => import('../views/CarParking.vue')
  },
  {
    path: '/autos',
    name: 'Autos',
    component: () => import('../views/Autos.vue')
  },
  {
    path: '/marcas',
    name: 'Marcas',
    component: () => import('../views/Marcas.vue')
  },
  {
    path: '/puestos',
    name: 'Puestos',
    component: () => import('../views/Puestos.vue')
  },
  {
    path: '/personas',
    name: 'Personas',
    component: () => import('../views/Personas.vue')
  },
  {
    path: '/personaadd/:id',
    name: 'PersonaAdd',
    component: () => import('../views/PersonaAdd.vue')
  },
  {
    path: '/personaentrada/:id',
    name: 'PersonaEntrada',
    component: () => import('../views/PersonaEntrada.vue')
  },
  {
    path: '/*',
    name: '404',
    component: () => import('../views/404.vue')
  },

  /* {
    path: '/temporal',
    name: 'Temporal',
    component: () => import('../views/Temporal.vue')
  } */

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
